export const isNew = createdAt => {
  const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000
  return Date.now() - new Date(createdAt).getTime() < SEVEN_DAYS_MS
}

export const isNewUser = createdAt => {
  const ONE_DAY_MS = 24 * 60 * 60 * 1000
  return Date.now() - new Date(createdAt).getTime() < ONE_DAY_MS
}
